export default function Terms() {
  return (
    <div className="container mt-5">
      <h1>Terms of Service for Devil Rank</h1>
      <p>
        <strong>Effective Date: 08/18/26</strong>
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By downloading, accessing, or using the Devil Rank mobile app (the
        "App"), you agree to be bound by these Terms of Service. If you do not
        agree to these terms, please do not use the App.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        Devil Rank provides Marine Corps promotion cutting score information
        and related tools, including score history, trend charts, and
        optional push notifications when new scores are released. The App is
        provided for informational purposes only.
      </p>

      <h2>3. Not an Official U.S. Marine Corps or DoD Product</h2>
      <p>
        Devil Rank is an independently developed app and is not affiliated
        with, endorsed by, or sponsored by the United States Marine Corps,
        the Department of Defense, or any other government entity. Cutting
        score data is sourced from publicly available official releases;
        while we make reasonable efforts to keep this data accurate and
        up to date, you should always confirm your official standing through
        your official military channels before making any career decisions.
      </p>

      <h2>4. Accounts</h2>
      <p>
        Some features of the App (such as saving your profile and receiving
        push notifications) require signing in with Apple. You are
        responsible for maintaining the security of your account and for all
        activity that occurs under it.
      </p>

      <h2>5. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the App for any unlawful purpose or in violation of these Terms.</li>
        <li>
          Attempt to interfere with, disrupt, or gain unauthorized access to
          the App, its servers, or its underlying data.
        </li>
        <li>
          Reverse engineer, decompile, or attempt to extract the source code
          of the App, except as permitted by applicable law.
        </li>
      </ul>

      <h2>6. Advertising</h2>
      <p>
        The App displays advertisements served through third-party ad
        networks to support free access to the App. See our{" "}
        <a href="/privacy">Privacy Policy</a> for details on how ad-related
        data is handled.
      </p>

      <h2>7. Disclaimer of Warranties</h2>
      <p>
        The App is provided "as is" and "as available" without warranties of
        any kind, whether express or implied. We do not warrant that the App
        will be uninterrupted, error-free, or that cutting score data will be
        complete or accurate at all times.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Devil Rank and its developers
        shall not be liable for any indirect, incidental, special, or
        consequential damages arising out of or related to your use of, or
        inability to use, the App, including but not limited to decisions
        made based on information provided by the App.
      </p>

      <h2>9. Changes to the App or Terms</h2>
      <p>
        We may modify or discontinue features of the App, and may update
        these Terms from time to time. If we make material changes, we will
        update the "Effective Date" above. Continued use of the App after
        changes take effect constitutes acceptance of the updated Terms.
      </p>

      <h2>10. Termination</h2>
      <p>
        We reserve the right to suspend or terminate access to the App for
        any user who violates these Terms.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions about these Terms, please reach out via our{" "}
        <a href="/support">Support page</a>.
      </p>
    </div>
  );
}
